// Styles
import "vuetify/styles";
import { aliases, md } from "vuetify/iconsets/md";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  icons: {
    defaultSet: "md",
    aliases,
    sets: {
      md,
    },
  },
  theme: {
    defaultTheme: "tdp",
    themes: {
      tdp: {
        colors: {
          primary: "#4f4f4f",
          accent: "#1e196a",
          error: "#ff5252",
          secondary: "#878787",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
    },
  },
});
